<template>
  <div class="page-card">
    <h2 class="page-title">资源位定义管理</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="query.keyword"
          placeholder="名称/编码/页面编码"
          clearable
          style="width: 240px"
        />
        <el-input
          v-model="query.pageCode"
          placeholder="页面编码"
          clearable
          style="width: 160px"
        />
        <el-select v-model="query.terminalType" clearable placeholder="展示端" style="width: 130px">
          <el-option v-for="item in terminalTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="query.status" clearable placeholder="状态" style="width: 120px">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
        <el-button type="primary" @click="fetchData">查询</el-button>
      </div>
      <div class="toolbar-right">
        <el-button v-if="canViewItems" @click="goResourceItems()">查看全部投放项</el-button>
        <el-button v-if="canCreate" type="primary" @click="openDialog()">新建资源位</el-button>
      </div>
    </div>

    <el-table :data="list" border>
      <el-table-column prop="positionName" label="名称" min-width="180" />
      <el-table-column prop="positionCode" label="编码" min-width="150" />
      <el-table-column prop="pageCode" label="页面编码" min-width="140" />
      <el-table-column label="展示端" width="120">
        <template slot-scope="{ row }">
          {{ terminalTypeLabel(row.terminalType) }}
        </template>
      </el-table-column>
      <el-table-column label="资源位类型" min-width="150">
        <template slot-scope="{ row }">
          {{ positionTypeLabel(row.positionType) }}
        </template>
      </el-table-column>
      <el-table-column prop="layoutStyle" label="布局样式" width="130" />
      <el-table-column prop="displayLimit" label="最大展示数" width="120" />
      <el-table-column label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="操作" width="360">
        <template slot-scope="{ row }">
          <el-button v-if="canViewItems" type="text" @click="goResourceItems(row)">投放项管理</el-button>
          <el-button v-if="canUpdate" type="text" @click="openDialog(row)">编辑</el-button>
          <el-button
            v-if="row.status === 1 && canDisable"
            type="text"
            @click="changeStatus(row, 'disable')"
          >
            停用
          </el-button>
          <el-button
            v-if="row.status !== 1 && canEnable"
            type="text"
            @click="changeStatus(row, 'enable')"
          >
            启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑资源位定义' : '新建资源位定义'" :visible.sync="dialogVisible" width="620px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="资源位编码" prop="positionCode">
          <el-input v-model="form.positionCode" />
        </el-form-item>
        <el-form-item label="资源位名称" prop="positionName">
          <el-input v-model="form.positionName" />
        </el-form-item>
        <el-form-item label="页面编码" prop="pageCode">
          <el-input v-model="form.pageCode" />
        </el-form-item>
        <el-form-item label="展示端" prop="terminalType">
          <el-select v-model="form.terminalType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in terminalTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="资源位类型" prop="positionType">
          <el-select v-model="form.positionType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in positionTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="布局样式">
          <el-input v-model="form.layoutStyle" />
        </el-form-item>
        <el-form-item label="最大展示数">
          <el-input-number v-model="form.displayLimit" :min="0" :step="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="排序值">
          <el-input-number v-model="form.sortNo" :min="0" :step="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { hasPermission } from '../../../utils/auth'
import {
  createOpsResourcePosition,
  disableOpsResourcePosition,
  enableOpsResourcePosition,
  getOpsResourcePositions,
  updateOpsResourcePosition
} from '../../../api/opsResourcePosition'

const terminalTypeOptions = [
  { label: '小程序', value: 1 },
  { label: 'H5', value: 2 },
  { label: 'PC', value: 3 },
  { label: '全端', value: 4 }
]

const positionTypeOptions = [
  { label: '轮播', value: 1 },
  { label: '首页分类区', value: 2 },
  { label: '热门通告', value: 3 },
  { label: '精选商家', value: 4 },
  { label: '推荐艺人', value: 5 },
  { label: '活动专区', value: 6 },
  { label: '自定义', value: 7 }
]

function getDefaultForm() {
  return {
    id: '',
    positionCode: '',
    positionName: '',
    pageCode: '',
    terminalType: 1,
    positionType: undefined,
    layoutStyle: '',
    displayLimit: 0,
    sortNo: 0,
    remark: ''
  }
}

export default {
  name: 'OpsResourcePositionPage',
  data() {
    return {
      list: [],
      query: {
        keyword: '',
        status: undefined,
        pageCode: '',
        terminalType: undefined
      },
      dialogVisible: false,
      form: getDefaultForm(),
      terminalTypeOptions,
      positionTypeOptions,
      rules: {
        positionCode: [{ required: true, message: '请输入资源位编码', trigger: 'blur' }],
        positionName: [{ required: true, message: '请输入资源位名称', trigger: 'blur' }],
        pageCode: [{ required: true, message: '请输入页面编码', trigger: 'blur' }],
        terminalType: [{ required: true, message: '请选择展示端', trigger: 'change' }],
        positionType: [{ required: true, message: '请选择资源位类型', trigger: 'change' }]
      }
    }
  },
  computed: {
    canCreate() {
      return hasPermission('ops_resource_position:create')
    },
    canUpdate() {
      return hasPermission('ops_resource_position:update')
    },
    canEnable() {
      return hasPermission('ops_resource_position:enable')
    },
    canDisable() {
      return hasPermission('ops_resource_position:disable')
    },
    canViewItems() {
      return hasPermission('ops_resource_item:view')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    terminalTypeLabel(value) {
      const target = this.terminalTypeOptions.find(item => item.value === value)
      return target ? target.label : '-'
    },
    positionTypeLabel(value) {
      const target = this.positionTypeOptions.find(item => item.value === value)
      return target ? target.label : '-'
    },
    async fetchData() {
      this.list = await getOpsResourcePositions(this.query)
    },
    goResourceItems(row) {
      const query = row && row.id ? { positionId: row.id, positionName: row.positionName } : {}
      this.$router.push({ path: '/ops/delivery/resource-items', query })
    },
    openDialog(row) {
      this.dialogVisible = true
      this.form = row
        ? {
            ...getDefaultForm(),
            ...row
          }
        : getDefaultForm()
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (this.form.id) {
          await updateOpsResourcePosition(this.form.id, this.form)
        } else {
          await createOpsResourcePosition(this.form)
        }
        this.dialogVisible = false
        await this.fetchData()
      })
    },
    async changeStatus(row, type) {
      if (type === 'enable') {
        await enableOpsResourcePosition(row.id)
      } else {
        await disableOpsResourcePosition(row.id)
      }
      await this.fetchData()
    }
  }
}
</script>
